import styled, { css } from 'styled-components/macro';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    cursor: pointer;

    .tabInfoText {
      display: none;

      ${theme.tokens.media.desktop} {
        display: inline-block;
      }
    }
  `};
`;
